import {useEffect} from "react";

export const useDrmInformationFont = () => {
    useEffect(() => {
        // コンポーネントがマウントされたときにクラスを追加
        document.body.classList.add('drmInformation-font');

        // コンポーネントがアンマウントされたときにクラスを削除
        return () => {
            document.body.classList.remove('drmInformation-font');
        };
    }, []);
}